export const FETCH_SERVICIOS_REQUEST = "FETCH_SERVICIOS_REQUEST";
export const FETCH_SERVICIOS_SUCCESS = "FETCH_SERVICIOS_SUCCESS";
export const FETCH_SERVICIOS_FAILURE = "FETCH_SERVICIOS_FAILURE";
